module.exports = __webpack_public_path__ + "static/media/Slider1.b80b162a.png";